The identifier for the candidate that applied for the position opening. This corresponds to the `Candidate.documentId` field in the GraphQL schema.
